import type { FC } from "react";

import type { LooseAutocomplete } from "@jti/commerce/shared";
import type { OrderItem as CartItem, SelectedBundleOptionValue } from "@jti/magento";

import ProductEntry from "@checkout/components/SummarySubscription/ProductEntry/ProductEntry";

import { getBundleQuantityCount } from "./getBundleQuantityCount/getBundleQuantityCount";

import styles from "./SummarySubscriptionItem.module.scss";

export type ProductType = LooseAutocomplete<"bundle"> | undefined;

const displaySingleItem = (values: SelectedBundleOptionValue[] | undefined) => {
  if (!values) {
    return;
  }
  return (
    <>
      {values.map((option: SelectedBundleOptionValue) => {
        const product_name = "label" in option ? option.label : option.product_name;

        return (
          <li key={option.id} className={styles.singleItemList}>
            · {option.quantity}x {product_name}
          </li>
        );
      })}
    </>
  );
};

const getQuantityString = (quantity: number, numberOfPacks: number, sticksInPack: number) => {
  return `${quantity * numberOfPacks} packs (${quantity * numberOfPacks * sticksInPack} sticks)`;
};

type SummarySubscriptionItemProps = Omit<CartItem, "product_type"> & { product_type?: ProductType };

const SummarySubscriptionItem: FC<SummarySubscriptionItemProps> = ({
  id,
  name,
  imageUrl,
  price,
  quantity,
  bundle_options,
  product_type,
}) => {
  const numberOfPacks = getBundleQuantityCount(bundle_options, product_type);
  const NUMBER_OF_STICKS_IN_PACK = 20;
  const description = getQuantityString(quantity, numberOfPacks, NUMBER_OF_STICKS_IN_PACK);

  return (
    <li className={styles.subscriptionProduct} data-testid="SummaryCartSubscriptionItem">
      <ProductEntry title={name} description={description} price={price} imageUrl={imageUrl}>
        {bundle_options && (
          <ol key={`list-${id}`}>{bundle_options?.map(({ values }) => values && displaySingleItem(values))}</ol>
        )}
      </ProductEntry>
    </li>
  );
};

export default SummarySubscriptionItem;
